<template>
  <div v-tooltip.top="tooltip" class="p-v4 m-v-4">
    <donut-selector-single-static v-model="selection" :options="options" :class="{ disabled: props.disabled }" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    modelValue: { type: String, default: 'full_onboarding_access' },
    disabled: { type: Boolean, default: false },
  });
  const emit = defineEmits(['update:modelValue']);

  const options = [
    { value: 'full_onboarding_access', label: 'Full Access' },
    { value: 'limited_onboarding_access', label: 'Limited Access' },
  ];
  const selection = computed({
    get() { return options.find((o) => o.value === props.modelValue); },
    set({ value }) { emit('update:modelValue', value); },
  });
  const tooltip = computed(() => {
    if (props.modelValue === 'full_onboarding_access') return 'This user has full access to Donut Journeys';
    return 'This user can not add or remove other admins in Donut Journeys';
  });
</script>
